




import { pageFactory } from '@/main/pages/pageFactory';
import { pageStoreBuilder } from '@/main/store/pages/page/builder';

const name = 'ArchyvPohybuDokladuListIframe';

export default pageFactory(name, pageStoreBuilder({
	name,
	crumbLabel: 'confused-nick-young',
	dropdownList: {},
	localState: {},
	props: {
		mode: null,
	},
}));
